<template>
  <v-dialog v-model="show" max-width="800px" lazy>
    <v-card>
      <v-card-text class="pa-4">
        <h3 class="mb-3 blue-grey--text text--lighten-2 text-uppercase">{{ value_title }}</h3>
        <div v-html="value_data_text" class="news-item"></div>
      </v-card-text>
      <v-card-actions>
        <div class="ml-3">
          <v-icon size="18" color="blue-grey lighten-3">access_time</v-icon>
          <span class="ml-1 blue-grey--text text--lighten-3">{{ value_date }}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="show = false">{{ $t('Close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    value_title() {
      return this.value && this.value.title;
    },
    value_date() {
      return this.value && this.value.smartDate;
    },
    value_data() {
      return this.value && this.value.data;
    },
    value_data_text() {
      return this.value_data && this.value.data.text;
    }
  },
  watch: {
    value(val) {
      if (!!val) {
        this.show = true;
      }
    },
    show(val) {
      if (!val) {
        this.$emit('show', val);
      }
    }
  }
}
</script>

<style scoped>
</style>